<div class="tab-item-content-container">
  <ng-template tab-content-container></ng-template>
</div>
